import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setSubmitMessage('Please enter your email');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d61qqq0omoleh5thvos0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitMessage('Thank you for subscribing!');
        setEmail('');
      } else {
        setSubmitMessage('Something went wrong. Please try again.');
      }
    } catch (error) {
      setSubmitMessage('Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer id="contact" className="bg-[#1A1F2E] rounded-t-[40px] mt-20 mx-4 lg:mx-8">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
          <div>
            <h3 className="text-4xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Travel with<br />Confidence
            </h3>
            <div className="w-16 h-1 bg-[#C9A961] mt-8"></div>
          </div>

          <div>
            <h4 className="text-white text-lg font-semibold mb-6">Explore</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => window.REACT_APP_NAVIGATE('/family-holidays-destinations')}
                  className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer text-left"
                >
                  Family Holidays
                </button>
              </li>
              <li>
                <a href="#accommodations" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer">
                  Accommodations
                </a>
              </li>
              <li>
                <a href="#family-travel" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer">
                  Family Travel
                </a>
              </li>
              <li>
                <button 
                  onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                  className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer text-left"
                >
                  Group Bookings
                </button>
              </li>
              <li>
                <a href="#about" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-lg font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:02034884455" className="text-gray-400 hover:text-[#C9A961] transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-phone-line text-[#C9A961] text-lg"></i>
                  0203 4884455
                </a>
              </li>
              <li>
                <a href="https://wa.me/447362505895" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#C9A961] transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-whatsapp-line text-[#C9A961] text-lg"></i>
                  +44 7362 505895
                </a>
              </li>
              <li>
                <a href="mailto:contact@alwaz.travel" className="text-gray-400 hover:text-[#C9A961] transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-mail-line text-[#C9A961] text-lg"></i>
                  contact@alwaz.travel
                </a>
              </li>
              <li className="pt-3">
                <h5 className="text-white text-sm font-semibold mb-2">Follow Us</h5>
                <div className="flex gap-3">
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-xl"></i>
                  </a>
                  <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer">
                    <i className="ri-youtube-line text-xl"></i>
                  </a>
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer">
                    <i className="ri-facebook-line text-xl"></i>
                  </a>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-lg font-semibold mb-6">Legal</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => window.REACT_APP_NAVIGATE('/privacy-policy')}
                  className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer text-left"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button
                  onClick={() => window.REACT_APP_NAVIGATE('/terms-and-conditions')}
                  className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer text-left"
                >
                  Terms &amp; Conditions
                </button>
              </li>
              <li>
                <button
                  onClick={() => window.REACT_APP_NAVIGATE('/cookie-policy')}
                  className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer text-left"
                >
                  Cookie Policy
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-lg font-semibold mb-4 leading-relaxed">
              Stay updated with exclusive<br />travel offers and tips
            </h4>
            <form onSubmit={handleSubmit} className="mt-6" data-readdy-form>
              <input type="hidden" name="form-id" value="newsletter-footer" />
              <div className="flex items-center bg-[#3A4556] rounded-full overflow-hidden">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="flex-1 bg-transparent text-white px-6 py-3 outline-none text-sm placeholder-gray-400"
                  disabled={isSubmitting}
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-10 h-10 bg-white rounded-full flex items-center justify-center mr-1 hover:bg-gray-100 transition-colors cursor-pointer disabled:opacity-50"
                  aria-label="Subscribe"
                >
                  <i className="ri-arrow-right-line text-[#1A1F2E]"></i>
                </button>
              </div>
              {submitMessage && (
                <p className={`text-sm mt-2 ${submitMessage.includes('Thank you') ? 'text-[#C9A961]' : 'text-red-400'}`}>
                  {submitMessage}
                </p>
              )}
            </form>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-col md:flex-row items-center gap-4">
              <p className="text-gray-400 text-sm">
                © 2024 Alwaz Travel London. Part of Nex Pro Travels Limited. All rights reserved.
              </p>
              <div className="flex items-center gap-4 text-gray-400 text-sm">
                <button
                  onClick={() => window.REACT_APP_NAVIGATE('/privacy-policy')}
                  className="hover:text-[#C9A961] transition-colors cursor-pointer"
                >
                  Privacy
                </button>
                <span>•</span>
                <button
                  onClick={() => window.REACT_APP_NAVIGATE('/terms-and-conditions')}
                  className="hover:text-[#C9A961] transition-colors cursor-pointer"
                >
                  Terms
                </button>
                <span>•</span>
                <button
                  onClick={() => window.REACT_APP_NAVIGATE('/cookie-policy')}
                  className="hover:text-[#C9A961] transition-colors cursor-pointer"
                >
                  Cookies
                </button>
              </div>
            </div>
            <a 
              href="https://www.techwaz.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 text-sm hover:text-[#C9A961] transition-colors cursor-pointer"
            >
              Website Developed by <span className="text-[#C9A961] font-semibold">TechWaz</span>
            </a>
          </div>
        </div>

        <div className="text-[#252B3A] text-8xl font-bold text-center mt-8 select-none pointer-events-none">
          ALWAZ TRAVEL
        </div>
      </div>
    </footer>
  );
}